(ns kyber.styles.spacing
  (:refer-clojure :exclude [double]))

(def spacing {:p0 "0"
              :p2 "2px"
              :p1 "1px"
              :p4 "4px"
              :p6 "6px"
              :p8 "8px"
              :p12 "12px"
              :p16 "16px"
              :p20 "20px"
              :p24 "24px"
              :p28 "28px"
              :p32 "32px"
              :p36 "36px"
              :p40 "40px"
              :p44 "44px"
              :p48 "48px"
              :p52 "52px"
              :p56 "56px"
              :p60 "60px"
              :p64 "64px"
              :p170 "170px"
              :p270 "270px"
              :-p0 "-0"
              :-p2 "-2px"
              :-p1 "-1px"
              :-p4 "-4px"
              :-p8 "-8px"
              :-p12 "-12px"
              :-p16 "-16px"
              :-p20 "-20px"
              :-p24 "-24px"
              :-p28 "-28px"
              :-p32 "-32px"
              :-p36 "-36px"
              :-p40 "-40px"
              :-p44 "-44px"
              :-p48 "-48px"
              :-p52 "-52px"
              :-p56 "-56px"
              :-p60 "-60px"
              :-p64 "-64px"})
